// 总节点
import React, { useEffect } from "react";
import * as echarts from "echarts";
export default function NodeData(props) {
  const option = {
    tooltip: {
      trigger: "item",
    },
    legend: {
      // 图例
      show: false,
      top: "5%",
      left: "center",
    },
    series: [
      {
        name: "总节点",
        type: "pie",
        radius: ["40%", "90%"],
        avoidLabelOverlap: false,
        label: {
          show: false,
          position: "center",
          // formatter(param) {
          //   console.log(param);
          //   // correct the percentage
          //   return param.name + param.value;
          // },
        },
        emphasis: {
          label: {
            color: "#fff",
            show: true,
            fontSize: 16,
            fontWeight: "bold",
            formatter: "{c}\n\n{b}",
          },
        },
        labelLine: {
          show: false,
        },

        data: [
          { value: 117, name: "总节点" },
          { value: 0, name: "待审核" },
          { value: 117, name: "服务中" },
          { value: 89, name: "在线" },
          { value: 28, name: "离线" },
        ],
      },
    ],
  };

  useEffect(() => {
    let timer = null;
    var myEchart = echarts.init(document.getElementById("node"));
    myEchart.setOption(option);
    window.addEventListener("resize", function () {
      myEchart.resize();
    });
    //   自动播放
    let myChartPieIndex = 0;

    // 鼠标移入事件
    myEchart.on("mouseover", (e) => {
      console.log(e);
      clearInterval(timer);
      // myChartPieIndex = e.dataIndex;
    });

    // 鼠标移出事件
    myEchart.on("mouseout", (e) => {
      goMove();
    });

    // 动画事件
    const goMove = () => {
      timer = setInterval(function () {
        var dataLen = option.series[0].data.length;
        // 取消之前高亮的图形
        myEchart.dispatchAction({
          type: "downplay",
          seriesIndex: 0,
          dataIndex: myChartPieIndex,
        });
        myChartPieIndex = (myChartPieIndex + 1) % dataLen;
        // 高亮当前图形
        myEchart.dispatchAction({
          type: "highlight",
          seriesIndex: 0,
          dataIndex: myChartPieIndex,
        });
      }, 1000);
    };
    goMove();
  }, []);
  return (
    <>
      <div className={props.cname}>
        <span className="node-title">总节点</span>
        <div
          id="node"
          className="node"
          style={{ width: "100%", height: "100%" }}
        ></div>
      </div>
    </>
  );
}
